/**
 * <announcement-bar>: one message at a time with prev/next buttons and an
 * optional auto-rotation. Rotation pauses on hover, focus, hidden tabs and
 * is disabled for prefers-reduced-motion.
 */
if (!customElements.get('announcement-bar')) {
  customElements.define(
    'announcement-bar',
    class AnnouncementBar extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.announcement__item'));
        if (this.items.length < 2) return;
        // Exactly one message is visible at any time (never zero).
        const visible = this.items.findIndex((item) => !item.hidden);
        this.index = visible < 0 ? 0 : visible;
        this.items.forEach((item, i) => (item.hidden = i !== this.index));
        this.interval = Number(this.dataset.interval) || 5000;
        this.auto = !this.hasAttribute('data-static') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(-1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(1, true));

        ['mouseenter', 'focusin'].forEach((type) => this.addEventListener(type, () => this.stop()));
        ['mouseleave', 'focusout'].forEach((type) => this.addEventListener(type, () => this.start()));
        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        document.addEventListener('visibilitychange', this.onVisibility);

        this.addEventListener('shopify:block:select', (event) => {
          this.stop();
          this.show(this.items.indexOf(event.target));
        });

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      start() {
        if (!this.auto || this.contains(document.activeElement)) return;
        this.stop();
        this.timer = setInterval(() => this.go(1), this.interval);
      }

      stop() {
        clearInterval(this.timer);
      }

      go(step, manual = false) {
        this.show((this.index + step + this.items.length) % this.items.length);
        if (manual) this.querySelector('.announcement__track').setAttribute('aria-live', 'polite');
      }

      show(index) {
        const item = this.items[index];
        if (!item || index === this.index) return;
        item.hidden = false;
        if (this.items[this.index]) this.items[this.index].hidden = true;
        this.index = index;
        item.classList.remove('is-entering');
        void item.offsetWidth;
        item.classList.add('is-entering');
      }
    }
  );
}
